import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {Widget} from 'Event/Widget/template'
import {useOrganization} from 'organization/OrganizationProvider'
import {useMutation, useQueryClient} from 'react-query'

export function useUpdateWidget() {
  const {event} = useEvent()
  const {client} = useOrganization()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (data: Widget) => {
      const url = api(`/events/${event.id}/widgets`)
      return client.put<Widget>(url, data)
    },
    onSuccess: (updated) => {
      qc.setQueryData<Widget>(['events', event.id, 'widgets'], () => updated)
    },
  })
}
